// 电子围栏路由
export default [{
  path: 'electronicFenceProject',
  name: 'electronicFenceProject',
  component: function component() {
    return import('@/views/bidManage/electronicFenceProject/index');
  }
}, {
  path: 'electronicFenceProjectAdd',
  name: 'electronicFenceProjectAdd',
  component: function component() {
    return import('@/views/bidManage/electronicFenceProject/add');
  }
}, {
  path: 'electronicFenceProjectDetail',
  name: 'electronicFenceProjectDetail',
  component: function component() {
    return import('@/views/bidManage/electronicFenceProject/detail');
  }
}];